export default {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  GET_USER_REQUEST: 'GET_USER_REQUEST',
  GET_USER_STATUS: 'GET_USER_STATUS',
  START_FETCHING_LOGIN: 'START_FETCHING_LOGIN',
  STOP_FETCHING_LOGIN: 'STOP_FETCHING_LOGIN',
  SET_ERRORS_LOGIN: 'SET_ERRORS_LOGIN',
  SET_ERROR_LOGIN: 'SET_ERROR_LOGIN',
  SET_ERROR_LOGIN_CRM: 'SET_ERROR_LOGIN_CRM',
};